'use strict';

var contactPhone = $('.contact-form #phone');
var scrollAnimate = require('base/components/scrollAnimate');
var loadRecaptchaV3 = require('./recaptchaV3');

// First section jump to form animation
$('.contact-us-scroll').click(function () {
    scrollAnimate($('.contact-form-anchor'));
});

// Handle mobile form input on checkbox interaction
$('#keepcurrentsms').click(function () {
    if ($(this).is(':checked')) {
        $('.contact-sms-container').removeClass('d-none');
        $('#sms-phone').prop('required', true);
    } else {
        $('.contact-sms-container').addClass('d-none');
        $('#sms-phone').prop('required', false).removeClass('is-invalid').val('');
    }
});

// Scroll to contact form error section of 5 error locations
$('.contact-form-button button').click(function () {
    var scrollToError;
    setTimeout(function () {
        if ($('.contact-form #inquiryType, .contact-form #message').hasClass('is-invalid')) {
            scrollToError = '.contact-form .country-and-state';
        }

        if ($('.contact-form #dbaname, .contact-form #address1, .contact-form select[name=dwfrm_contact_address_country], .contact-form select[name=dwfrm_contact_states_stateCode], .contact-form input[name=dwfrm_contact_states_stateCode], .contact-form #city, .contact-form #zipCode').hasClass('is-invalid')) {
            if ($('.contact-form .contact-sms-container').hasClass('d-none')) {
                scrollToError = '.keep-current-title';
            } else {
                scrollToError = '.contact-form .contact-sms-container';
            }
        }

        if ($('#sms-phone').hasClass('is-invalid')) {
            scrollToError = 'form.contact-form #firstName';
        }

        if ($('.contact-form #firstName, .contact-form #lastName, .contact-form #email, .contact-phone-error').hasClass('is-invalid') || contactPhone.hasClass('is-invalid')) {
            scrollToError = '.contact-form-anchor';
        }

        if (scrollToError) {
            scrollAnimate($(scrollToError));
        }
    }, 100);
});

/**
 * Handle successful contact form submit
 */
function contactFormSubmit() {
    var form = $('.contact-form');
    var url = form.attr('action');
    form.spinner().start();

    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function () {
            $('.contact-form-container').addClass('contact-modal');
            $('.before-submit').remove();
            $('.after-submit').removeClass('d-none');
            form.remove();
            setTimeout(function () {
                scrollAnimate($('.contact-modal-anchor'));
            }, 50);
            form.spinner().stop();
        }
    });
}

/**
 * replace keep current sms section with email content
 */
function keepCurrentEmail() {
    $('.kc-form-feedback').html('');
    $('#contactkeepcurrent-input').val('');
    $('.kc-form-sms').fadeOut(0).addClass('d-none');
    $('.kc-form-email').fadeIn(500).removeClass('d-none');
}

/**
 * replace keep current email section with sms content
 */
function keepCurrentSMS() {
    if ($('.contact-keep-current input[name=attn-included]').val()) {
        $('.kc-form-feedback').html('');
        $('#sms-number-kc').val('');
        $('.kc-form-sms .attn-disclaimer .load-message').removeClass('d-none').fadeIn(0);
        $('.kc-form-sms .attn-disclaimer .return-message').fadeOut(0).html('').addClass('d-none');
        $('.kc-form-email').fadeOut(0).addClass('d-none');
        $('.kc-form-sms').fadeIn(500).removeClass('d-none');
        $('#sms-number-kc').focus();
    } else {
        keepCurrentEmail();
    }
}

/**
 * render contact keep current form
 * @param {*} formData data
 * @return {string} content
 */
function renderKCForm(formData) {
    var form = $('#contact-email-alert-signup');
    var url = form.attr('action');
    $(this).attr('disabled', true);
    $('.kc-form-feedback').removeClass('kc-error').html('');
    $('#contactkeepcurrent-input').removeClass('contact-invalid');
    $.ajax({
        url: url,
        type: 'post',
        data: formData,
        success: function (data) {
            if (data.success) {
                $('input[name=mcEmailSignupContact]').val('');
                $('.kc-form-feedback').html('Succuss! You are subscribed.');
                setTimeout(function () {
                    $('.kc-form-email').fadeOut(0);
                    keepCurrentSMS();
                }, 1500);
            } else {
                $('.kc-form-feedback').addClass('kc-error').html(data.msg);
                $('#contactkeepcurrent-input').addClass('contact-invalid');
            }
        },
        error: function () {
            $('input[name=mcEmailSignupContact]').val('');
        }
    });
    return false;
}

/**
 * submit keep current email by enter key or button click
 */
function submitKCEmail() {
    var $email = $('input[name=mcEmailSignupContact]');
    if ($email.val().length > 0) {
        var emailId = $email.val();
        $.spinner().start();
        renderKCForm({ emailId: emailId });
        $.spinner().stop();
    } else {
        $('.kc-form-feedback').addClass('kc-error').html('Please fill out this field.');
        $('#contactkeepcurrent-input').addClass('contact-invalid');
    }
}

/**
 * submit keep current sms by enter key or button click
 */
function submitKCSMS() {
    $('.kc-form-feedback').removeClass('kc-error').html('');
    var phoneData = document.getElementById('sms-number-kc');
    var phoneInput = $('#sms-number-kc');
    var validityContact = null;
    $(phoneData).removeClass('contact-invalid');

    if ($(phoneInput).val().length > 0) {
        $.spinner().start();
        validityContact = phoneData.validity;

        if (validityContact && validityContact.patternMismatch === true) {
            phoneData.setCustomValidity(window.Resources.MOBILE_TEL_PATTERN_MISMATCH);
        } else {
            phoneData.setCustomValidity('');
        }

        if (phoneData.reportValidity()) {
            $.ajax({
                url: window.Urls.attentiveSubscribe,
                method: 'post',
                data: { smsNumber: phoneData.value }
            }).done((data) => {
                if (!data.error && data.code === 202) {
                    $('#sms-number-kc').val('');
                    $('.kc-form-sms .attn-disclaimer .load-message').fadeOut(100).addClass('d-none');
                    $('.kc-form-sms .attn-disclaimer .return-message').html(data.message).removeClass('d-none').fadeIn(100);
                    setTimeout(function () {
                        $('.kc-form-sms').fadeOut(20);
                        keepCurrentEmail();
                    }, 4000);
                } else {
                    var errorMsg = (data.errorText) || phoneData.getAttribute('data-pattern-mismatch');
                    $('.kc-form-feedback').addClass('kc-error').html(errorMsg);
                    $(phoneData).val('');
                    $(phoneData).addClass('contact-invalid');
                }
            }).fail(function () {
                $('.kc-form-feedback').addClass('kc-error').html(phoneData.getAttribute('data-pattern-mismatch'));
                $(phoneData).val('');
                $(phoneData).addClass('contact-invalid');
            });
        } else {
            $('.kc-form-feedback').addClass('kc-error').html(phoneData.getAttribute('data-pattern-mismatch'));
            $(phoneData).addClass('contact-invalid');
        }
        $.spinner().stop();
    } else {
        $('.kc-form-feedback').addClass('kc-error').html('Please fill out this field.');
        $(phoneData).addClass('contact-invalid');
    }
}

module.exports = {
    contactFormSubmit: function () {
        // Privacy: Google reCAPTCHA v3 is NOT loaded at page load. It loads on the
        // shopper's first interaction with the contact form so the token is ready
        // by submit time — and never loads for shoppers who don't use the form.
        $('.contact-form').one('focusin.recaptcha change.recaptcha', function () {
            loadRecaptchaV3();
        });

        $('.contact-form').on('submit', function (e) {
            e.preventDefault();
            loadRecaptchaV3(function () {
                window.grecaptcha.execute(window.SitePreferences.NEW_RECAPTCHA_SITE_KEY, { action: 'submit' })
                    .then(function (token) {
                        $('#g-recaptcha-response').val(token);
                        contactFormSubmit();
                    })
                    .catch(function (error) {
                        /* eslint-disable no-console */
                        console.log('reCaptcha Error:', error);
                        /* eslint-enable no-console */
                    });
            });
        });
    },

    contactKeepCurrent: function () {
        $(document).ready(function () {
            if ($('.contact-keep-current input[name=email-subscribed]').val()) {
                keepCurrentSMS();
            }
        });

        $('.contact-mc-subscribe-email').on('click', function (e) {
            e.preventDefault();
            submitKCEmail();
        });

        $('input[name=mcEmailSignupContact]').keypress(function (e) {
            var code = e.keyCode || e.which;
            if (code === 13) {
                e.preventDefault();
                submitKCEmail();
            }
        });

        $('input[name=mcEmailSignupContact], input[name=sms-number-kc]').on('click', function () {
            this.select();
        });

        $('input[name=sms-number-kc]').keypress(function (e) {
            var code = e.keyCode || e.which;
            if (code === 13) {
                e.preventDefault();
                submitKCSMS();
            }
        });

        $('#sms-optin-submit-contact, .contact-mc-subscribe-sms').on('click', function (e) {
            e.preventDefault();
            submitKCSMS();
        });
    }
};
